export default __webpack_public_path__ + "static/media/Google__G.d7f092af.svg";